import { render, staticRenderFns } from "./app-referral-popup.vue?vue&type=template&id=3191bf0f&scoped=true&"
import script from "./app-referral-popup.vue?vue&type=script&lang=ts&"
export * from "./app-referral-popup.vue?vue&type=script&lang=ts&"
import style0 from "./app-referral-popup.vue?vue&type=style&index=0&id=3191bf0f&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191bf0f",
  null
  
)

export default component.exports